export default __webpack_public_path__ + "static/media/SWIS Icon RGB.ab061dba.svg";